import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { useUserSettings } from './useUserSettings';
import { useLazyGetUserCustomerSettingsQuery } from 'api/userCustomerSettings';
import { notifyAuthChange } from 'utils/authUtils';
import { SetAllUserSettings } from 'store/reducers/userSettingsSlice';

export const useUserRedirect = () => {
  const { state } = useLocation();
  const dispatch = useDispatch();
  const userSettings = useSelector((state: RootState) => state.userSettings);

  const { getUserRoutingURL, SetUserSetting, isUserSettingsInitialized, GetUserCustomSettings, getCurrentLandingPageFromSession } =
    useUserSettings();

  const [fetchUserSetting] = useLazyGetUserCustomerSettingsQuery();

  const redirectToLandingPage = async () => {
    let landingPageValue: string | undefined;

    if (!isUserSettingsInitialized) {
      try {
        const userSettingData = await fetchUserSetting().unwrap();
        if (userSettingData) {
          await SetUserSetting(userSettingData);
          landingPageValue = userSettingData?.CurrentLandingPage?.value?.toString();
        } else {
          landingPageValue = userSettings?.CurrentLandingPage?.toString();
        }
      } catch (error) {}

      landingPageValue ||= getCurrentLandingPageFromSession;

      const routingURL = getUserRoutingURL(landingPageValue || '', state?.from);
      notifyAuthChange('login');
      window.location.href = routingURL || '/dashboard/admin';
      //clearTimeout(timer);
      //
    }
  };

  const initializeSessionFromStorage = () => {
    const sessionData = GetUserCustomSettings();
    dispatch(SetAllUserSettings(sessionData));
  };

  return {
    redirectToLandingPage,
    initializeSessionFromStorage
  };
};
